function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-4 -4)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  stroke: "#0668FF",
  cx: 12,
  cy: 12,
  r: 7.5
}), React.createElement("circle", {
  fill: "#0668FF",
  cx: 12,
  cy: 12,
  r: 5
}));

var SvgRadioCycleSelected = function SvgRadioCycleSelected(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTYgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUyLjMgKDY3Mjk3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5SYWRpby1jeWNsZS1zZWxlY3RlZDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJPdmFsLUNvcHktMTEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00LjAwMDAwMCwgLTQuMDAwMDAwKSI+CiAgICAgICAgICAgIDxjaXJjbGUgc3Ryb2tlPSIjMDY2OEZGIiBzdHJva2Utd2lkdGg9IjEiIGN4PSIxMiIgY3k9IjEyIiByPSI3LjUiPjwvY2lyY2xlPgogICAgICAgICAgICA8Y2lyY2xlIGZpbGw9IiMwNjY4RkYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY3g9IjEyIiBjeT0iMTIiIHI9IjUiPjwvY2lyY2xlPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgRadioCycleSelected as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./src/components/lib/Icons/SystemIcon/svg/radio-cycle-selected.svg
// module id = 908
// module chunks = 0